import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useIsPro() {
	const [isPro, setIsPro] = useState(false);
	const licence = useSelector((state) => state.main?.licenced?.checked);

	useEffect(() => {
		if (licence === true) setIsPro(true);
		else setIsPro(false);
	}, [licence]);

	return isPro;
}
